import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'templates.use-template-empty-database-name': {
    id: 'templates.use-template-empty-database-name',
    defaultMessage: 'Empty database',
    description: 'The name to use for empty database template'
  },
  'templates.use-template-content-library-name': {
    id: 'templates.use-template-content-library-name',
    defaultMessage: 'Content library',
    description: 'The name to use for content library template'
  },
  'templates.use-template-contact-library-name': {
    id: 'templates.use-template-contact-library-name',
    defaultMessage: 'Contact library',
    description: 'The name to use for contact library template'
  },
  'templates.use-template-vendor-management-name': {
    id: 'templates.use-template-vendor-management-name',
    defaultMessage: 'Vendor management',
    description: 'The name to use for vendor management template'
  },
  'templates.use-template-product-requirements-name': {
    id: 'templates.use-template-product-requirements-name',
    defaultMessage: 'Product requirements',
    description: 'The name to use for product requirements template'
  },
  'templates.use-template-research-repository-name': {
    id: 'templates.use-template-research-repository-name',
    defaultMessage: 'Research repository',
    description: 'The name to use for research repository template'
  },
  'templates.use-template-meeting-notes-name': {
    id: 'templates.use-template-meeting-notes-name',
    defaultMessage: 'Meeting notes',
    description: 'The name to use for meeting notes template'
  },
  'templates.use-template-content-calendar-name': {
    id: 'templates.use-template-content-calendar-name',
    defaultMessage: 'Content calendar',
    description: 'The name to use for content calendar template'
  },
  'templates.use-template-new-hire-name': {
    id: 'templates.use-template-new-hire-name',
    defaultMessage: 'New hire 90 day plan',
    description: 'The name to use for new hire 90 day plan template'
  },
  'templates.use-template-capacity-planning-name': {
    id: 'templates.use-template-capacity-planning-name',
    defaultMessage: 'Capacity planning',
    description: 'The name to use for capacity planning template'
  },
  'templates.use-template-feedback-tracker-name': {
    id: 'templates.use-template-feedback-tracker-name',
    defaultMessage: 'Feedback tracker',
    description: 'The name to use for feedback tracker template'
  },
  'templates.use-template-campaign-tracker-name': {
    id: 'templates.use-template-campaign-tracker-name',
    defaultMessage: 'Campaign tracker',
    description: 'The name to use for campaign tracker template'
  },
  'templates.use-template-okr-tracker-name': {
    id: 'templates.use-template-okr-tracker-name',
    defaultMessage: 'OKR tracker',
    description: 'The name to use for OKR tracker template'
  },
  'templates.use-template-budget-name': {
    id: 'templates.use-template-budget-name',
    defaultMessage: 'Budget',
    description: 'The name to use for budget template'
  },
  'templates.use-template-applicant-tracker-name': {
    id: 'templates.use-template-applicant-tracker-name',
    defaultMessage: 'Applicant tracker',
    description: 'The name to use for applicant tracker template'
  },
  // Template descriptions
  'templates.use-template-content-library-description': {
    id: 'templates.use-template-content-library-description',
    defaultMessage:
      'Use this template to store, categorize and keep track of important content in your organization. Track assets, articles, documents, media files in one centralized location for easy access and collaboration.',
    description: 'The description for the content library template'
  },
  'templates.use-template-product-requirements-description': {
    id: 'templates.use-template-product-requirements-description',
    defaultMessage:
      'Use this template to help organize your team’s product requirements in a single place. Track features, user stories, acceptance criteria and priority to enhance your product development process.',
    description: 'The description for the product requirements template'
  },
  'templates.use-template-campaign-tracker-description': {
    id: 'templates.use-template-campaign-tracker-description',
    defaultMessage:
      'Use this template to help your team manage and monitor all campaign activities in one centralized location. Track each campaign item’s stage and key details like dates & links, as well as what stage it is in. This template helps keep your team aligned and ensures every campaign stays on schedule.',
    description: 'The description for the campaign tracker template'
  },
  'templates.use-template-research-repository-description': {
    id: 'templates.use-template-research-repository-description',
    defaultMessage:
      'Use this template to help your team collect, organize and reference research findings in a single, searchable location. Capture research details, insights, sources or relevant files for easy access and collaboration.',
    description: 'The description for the research repository template'
  },
  'templates.use-template-contact-library-description': {
    id: 'templates.use-template-contact-library-description',
    defaultMessage:
      'Use this template to provide a centralized place to store and manage important contact information for your team or organization. Track things like names, roles, organizations and key details about each contact. Easily access, update, and share contact information to keep everyone connected and informed.',
    description: 'The description for the contact library template'
  },
  'templates.use-template-meeting-notes-description': {
    id: 'templates.use-template-meeting-notes-description',
    defaultMessage:
      'Use this template to help capture, organize and reference notes from all meetings in one place. Record agendas, attendees, key decisions or action items for each meeting. This helps keep your team aligned and ensures important information is easily accessible and trackable!',
    description: 'The description for the meeting notes template'
  },
  'templates.use-template-content-calendar-description': {
    id: 'templates.use-template-content-calendar-description',
    defaultMessage:
      'Use this template to plan, schedule and track content initiatives in a single organized board layout. Manage your deadlines, content types, publication dates and responsible owners all in one place.',
    description: 'The description for the content calendar template'
  },
  'templates.use-template-capacity-planning-description': {
    id: 'templates.use-template-capacity-planning-description',
    defaultMessage:
      'Use this template to help forecast, allocate and track resources for projects and tasks. Visualize your team’s availability, workload, project timelines and link each entry to relevant Jira work items for seamless tracking. This ensures you optimize resource utilization across your team.',
    description: 'The description for the capacity planning template'
  },
  'templates.use-template-feedback-tracker-description': {
    id: 'templates.use-template-feedback-tracker-description',
    defaultMessage:
      'Use this template to provide a structured way to collect, organize and track feedback from users, stakeholders or team members. You can categorize and prioritize feedback using tags as well as monitor resolution status as well as other relevant details, to ensure for a streamlined feedback process.',
    description: 'The description for the feedback tracker template'
  },
  'templates.use-template-okr-tracker-description': {
    id: 'templates.use-template-okr-tracker-description',
    defaultMessage:
      'Use this template to set, monitor and update Objectives and Key Results in one place. Align goals, track progress and keep everyone focused on priorities.',
    description: 'The description for the OKR tracker template'
  },
  'templates.use-template-budget-description': {
    id: 'templates.use-template-budget-description',
    defaultMessage:
      'Use this template to plan, track and manage expenses and allocations in one centralized location. Record budget categories, amounts, actual spend and key financial details to help provide visibility into your finances.',
    description: 'The description for the budget template'
  },
  'templates.use-template-applicant-tracker-description': {
    id: 'templates.use-template-applicant-tracker-description',
    defaultMessage:
      'Use this template to centralize candidate information and hiring stages for your recruitment process. Track applications, interview progress and key details for each applicant in a centralized location to ensure a smooth candidate experience.',
    description: 'The description for the applicant tracker template'
  },
  'templates.use-template-vendor-management-description': {
    id: 'templates.use-template-vendor-management-description',
    defaultMessage:
      'Use this template to help your team organize and monitor vendor relationships. Keep track of key vendor details, agreements and renewal dates all in one place to streamline your vendor management.',
    description: 'The description for the vendor management template'
  },
  'templates.use-template-new-hire-description': {
    id: 'templates.use-template-new-hire-description',
    defaultMessage:
      'Use this template to guide new employees through their onboarding journey with clear milestones and tasks. Outline goals, training and check-ins for the first 90 days in order to set them up for success from day one.',
    description: 'The description for the new hire template'
  },
  // Template keywords
  'templates.keyword.resource-management': {
    id: 'templates.keyword.resource-management',
    defaultMessage: 'resource management',
    description: 'Keyword tag for templates related to resource management'
  },
  'templates.keyword.project-management': {
    id: 'templates.keyword.project-management',
    defaultMessage: 'project management',
    description: 'Keyword tag for templates related to project management'
  },
  'templates.keyword.content-management': {
    id: 'templates.keyword.content-management',
    defaultMessage: 'content management',
    description: 'Keyword tag for templates related to content management'
  },
  'templates-preview.add-entry': {
    id: 'templates-preview.add-entry',
    defaultMessage: 'Add entry',
    description: 'The text to use for Add entry in template previews'
  },
  'templates-preview.text-field': {
    id: 'templates-preview.text-field',
    defaultMessage: 'Text field',
    description: 'The text to use for Text field in template previews'
  },
  'templates-preview.tag-field': {
    id: 'templates-preview.tag-field',
    defaultMessage: 'Tag field',
    description: 'The text to use for Tag field in template previews'
  },
  'templates-preview.user-field': {
    id: 'templates-preview.user-field',
    defaultMessage: 'User field',
    description: 'The text to use for User field in template previews'
  }
});
